/**
 * Guardas de rota. Fonte: docs/12 §2 (matriz de permissões).
 * Enquanto /auth/me não resolve, mostra um loader — nunca pisca a tela de login.
 */
import type { ReactNode } from "react";
import { Navigate } from "react-router";
import { useSession } from "../lib/session";

export function FullScreenLoader() {
  return (
    <div className="app-shell flex min-h-dvh items-center justify-center">
      <span
        aria-label="Carregando"
        className="h-6 w-6 animate-spin rounded-full border-2 border-text-tertiary border-t-transparent"
      />
    </div>
  );
}

/** Só a equipe (admin/editor). Caso contrário, manda para o login. */
export function RequireUser({ children }: { children: ReactNode }) {
  const { session, loading } = useSession();
  if (loading) return <FullScreenLoader />;
  if (!session || session.actorType !== "user") return <Navigate to="/entrar" replace />;
  return <>{children}</>;
}

/** Só a cliente (sessão de link mágico). */
export function RequireClient({ children }: { children: ReactNode }) {
  const { session, loading } = useSession();
  if (loading) return <FullScreenLoader />;
  if (!session || session.actorType !== "client") return <Navigate to="/entrar" replace />;
  return <>{children}</>;
}
